/* eslint-disable max-len */
import React, {FC} from "react"

import id from "@irati/utils/id"

import BaseSvgIcon from "./Base"

interface Props {
  id?: string
  title?: string
}

const Visibility: FC<Props> = ({id: _id = "visibility-icon", title = "Visibility", ...rest}) => {
  const props = {id: _id, title, ...rest}
  const titleId = id("title", props)

  return (
    <BaseSvgIcon {...rest} aria-labelledby={titleId}>
      <title id={titleId}>{title}</title>
      <g fill="none" fillRule="evenodd" strokeWidth="1">
        <rect width="18" height="18" rx="1" />
        <g transform="translate(3 6)" stroke="#3D3D36" strokeLinecap="round">
          <path
            transform="translate(6.0091 2.3252) rotate(-90) translate(-6.0091 -2.3252)"
            d="m4.3506 8.0814c1.9837-1.155 3.317-3.3045 3.317-5.7653 0-2.448-1.3194-4.5877-3.2858-5.747"
          />
          <path
            transform="translate(6.0069 5.6978) scale(1 -1) rotate(-90) translate(-6.0069 -5.6978)"
            d="m4.3713 11.429c1.9583-1.1613 3.2711-3.2965 3.2711-5.7384 0-2.4323-1.3025-4.5603-3.2481-5.7246"
          />
        </g>
        <path
          d="m9 11.5c0.82843 0 1.5-0.67157 1.5-1.5 0-0.82843-0.67157-1.5-1.5-1.5s-1.5 0.67157-1.5 1.5c0 0.82843 0.67157 1.5 1.5 1.5z"
          stroke="#3D3D36"
          strokeLinecap="round"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default Visibility
